var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleSelectDropdownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "double-arrow-icon",
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  #double-arrow-icon path { fill: #586069; }\n  #double-arrow-icon:not([color]) path { fill: #586069; }\n  #double-arrow-icon[color] path { fill: currentColor; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.426782 3.57318L3.82326 0.176738C3.92089 0.0791081 4.07918 0.0791081 4.17681 0.176738L7.5732 3.57318C7.7307 3.73068 7.6192 3.99996 7.3964 3.99996H0.603562C0.380832 3.99996 0.269292 3.73067 0.426782 3.57318Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.426782 7.42674L3.82326 10.8232C3.92089 10.9208 4.07918 10.9208 4.17681 10.8232L7.5732 7.42674C7.7307 7.26924 7.6192 6.99996 7.3964 6.99996H0.603562C0.380832 6.99996 0.269292 7.26925 0.426782 7.42674Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleSelectDropdownArrow);
export default __webpack_public_path__ + "static/media/single-select-dropdown-arrow.8ef2ce36.svg";
export { ForwardRef as ReactComponent };